var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOrbs = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 439 428",
    width: 439,
    height: 428,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 140.16,
    cy: 237.023,
    fill: "#052DFF",
    rx: 80.122,
    ry: 79.939,
    transform: "rotate(-79.278 140.16 237.023)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 242.369,
    cy: 210.218,
    r: 116.241,
    fill: "#D700A7",
    transform: "rotate(-79.278 242.369 210.218)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 279.918,
    height: 280.266,
    x: 0.201,
    y: 96.891,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_1389_25895",
    stdDeviation: 30
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: 392.525,
    height: 392.531,
    x: 46.105,
    y: 13.953,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_1389_25895",
    stdDeviation: 40
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOrbs);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/orbs.57282aba533486b55cc0862a94572e84.svg";